import { color, duration, spacing, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import Box from "../../Box/Box";
import { SwitchDot } from "./SwitchDot";
export const animationDuration = duration.animation.fast;
export const Switch = styled(Box) `
  background-color: ${color.background.dark};
  box-sizing: border-box;
  height: ${spacing.base.l};
  width: 43px;
  transition: background-color ${animationDuration}ms ease-in;
  cursor: pointer;
  justify-content: flex-start;
  border-radius: 12px;

  &.checked {
    background-color: ${color.status.success.default};

    &.destructive {
      background-color: ${color.status.error.default};
    }

    & > ${SwitchDot} {
      transform: translateX(19px);
    }
  }

  + * {
    cursor: pointer;
  }

  &.disabled {
    background-color: ${color.background.selectableBox.disabled};
    cursor: not-allowed;

    + * {
      cursor: not-allowed;
    }
  }

  &.disabled.checked {
    background-color: ${color.status.success.backgroundDark};
  }

  &.disabled.checked.destructive {
    background-color: ${color.status.error.backgroundDark};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3dpdGNoLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvU3dpdGNoL3N0eWxlZC9Td2l0Y2gudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUNMLEtBQUssRUFDTCxRQUFRLEVBQ1IsT0FBTyxHQUNSLE1BQU0sZ0RBQWdELENBQUM7QUFDeEQsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFDdkMsT0FBTyxHQUFHLE1BQU0sZUFBZSxDQUFDO0FBQ2hDLE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSxhQUFhLENBQUM7QUFFeEMsTUFBTSxDQUFDLE1BQU0saUJBQWlCLEdBQUcsUUFBUSxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUM7QUFFekQsTUFBTSxDQUFDLE1BQU0sTUFBTSxHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQTtzQkFDWCxLQUFLLENBQUMsVUFBVSxDQUFDLElBQUk7O1lBRS9CLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQzs7aUNBRU8saUJBQWlCOzs7Ozs7d0JBTTFCLEtBQUssQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLE9BQU87OzswQkFHMUIsS0FBSyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsT0FBTzs7O1VBRzFDLFNBQVM7Ozs7Ozs7Ozs7d0JBVUssS0FBSyxDQUFDLFVBQVUsQ0FBQyxhQUFhLENBQUMsUUFBUTs7Ozs7Ozs7O3dCQVN2QyxLQUFLLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxjQUFjOzs7O3dCQUluQyxLQUFLLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxjQUFjOztDQUV4RCxDQUFDIn0=